var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "info-root" }, [
    _c("div", { staticClass: "info-top info-box" }, [
      _c(
        "div",
        { staticClass: "info-title" },
        [
          !_vm.isLoadingConfiguration
            ? [
                _c(
                  "div",
                  { staticClass: "w-100" },
                  [
                    _c("info-title", { staticClass: "title-text" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.configuration.title) +
                          "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-outline-secondary btn-xs",
                        class: { disabled: !_vm.navigateToSelectedBrickUrl },
                        attrs: { href: _vm.navigateToSelectedBrickUrl }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.resource(
                                "JourneyBuilder_TouchpointInfo_ChangeTouchpoint"
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("info-sub-title", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.configuration.subTitle) +
                      "\n                "
                  )
                ])
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info-touchpoint-selectors" },
        [
          _c("v-select", {
            staticClass: "form-control",
            attrs: {
              placeholder: _vm.resource(
                "JourneyBuilder_TouchpointInfo_PreviousTouchpoint"
              ),
              options: _vm.previousTouchPoints,
              value: null,
              disabled: _vm.previousTouchPoints.length === 0
            },
            on: { input: _vm.selectTouchPoint }
          }),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "form-control",
            attrs: {
              placeholder: _vm.resource(
                "JourneyBuilder_TouchpointInfo_NextTouchpoint"
              ),
              options: _vm.nextTouchPoints,
              value: null,
              disabled: _vm.nextTouchPoints.length === 0
            },
            on: { input: _vm.selectTouchPoint }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "info-close-button" }, [
        _c(
          "button",
          {
            staticClass: "close",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.close($event)
              }
            }
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        )
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "info-nav-tabs" },
        _vm._l(_vm.tabs, function(tab) {
          return !_vm.isLoadingConfiguration
            ? _c(
                "li",
                {
                  key: tab.title,
                  staticClass: "info-nav-tab",
                  class: { active: tab === _vm.activeTab },
                  on: {
                    click: function($event) {
                      _vm.selectedTab = tab
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " + _vm._s(tab.title) + "\n            "
                  )
                ]
              )
            : _vm._e()
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "info-dashboard-navigation-button" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-outline-secondary btn-xs",
            class: { disabled: !_vm.navigateToDashboardUrl },
            attrs: { href: _vm.navigateToDashboardUrl || "#" }
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.resource(
                    "JourneyBuilder_Sankey_TouchpointInfo_OpenDashboard_Button"
                  )
                ) +
                "\n            "
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { ref: "widget-container", staticClass: "info-bottom info-box" },
      [
        _c(
          "div",
          { staticClass: "info-controls" },
          [
            !_vm.isLoadingPeriodRange
              ? [
                  _vm.startDate && _vm.endDate
                    ? _c("info-sub-title", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm._f("displayDate")(_vm.startDate)) +
                            " t/m " +
                            _vm._s(_vm._f("displayDate")(_vm.endDate)) +
                            "\n                "
                        )
                      ])
                    : _vm._e()
                ]
              : _c("loader"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "info-buttons" },
              [
                _vm.detailsButtonTarget
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        on: { click: _vm.scrollToDetailsTarget }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.resource(
                              "JourneyBuilder_Sankey_TouchpointInfo_Details_Button"
                            )
                          )
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeTab
                  ? _c("export-tab-button", {
                      attrs: {
                        tabId: _vm.activeTab.id,
                        "brick-id": _vm.selectedBrickId
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          2
        ),
        _vm._v(" "),
        !_vm.isLoadingConfiguration
          ? [
              _vm.activeTab
                ? _c(
                    "keep-alive",
                    [
                      _c(
                        "widgets-wrapper",
                        {
                          key: _vm.activeTab.title,
                          staticClass: "info-widgets"
                        },
                        _vm._l(_vm.widgets, function(widgetConfiguration) {
                          return _c("widget", {
                            key: widgetConfiguration.id,
                            staticClass: "info-widget",
                            attrs: {
                              id: _vm.formatWidgetDOMId(widgetConfiguration.id),
                              configuration: widgetConfiguration,
                              "brick-id": _vm.selectedBrickId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _c("label", [
                    _vm._v(_vm._s(_vm.resource("Chart_ErrorMessage_NoData")))
                  ])
            ]
          : _c("loader")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }